import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Pervasives from "bs-platform/lib/es6/pervasives.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Bolt0_string$Bolt0 from "bolt0/./bolt0_string.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

function Make(Record_param, Label) {
  var Private = {
    Record_param: Record_param,
    Label: Label
  };
  var $$Error = {};

  var numBins = Curry._1(Label.named_exn, "numBins");

  var binWeights = Curry._1(Label.named_exn, "binWeights");

  var dataWeights = Curry._1(Label.named_exn, "dataWeights");

  var columnName = Curry._1(Label.named_exn, "columnName");

  var data = Curry._1(Label.positional_exn, 1);

  var Label$1 = {
    numBins: numBins,
    binWeights: binWeights,
    dataWeights: dataWeights,
    columnName: columnName,
    data: data
  };

  var match = Curry._1(Record_param.R.of_alist,
  /* :: */
  [
  /* tuple */
  [numBins,
  /* Null */
  870828711],
  /* :: */
  [
  /* tuple */
  [binWeights,
  /* Null */
  870828711],
  /* :: */
  [
  /* tuple */
  [dataWeights,
  /* Null */
  870828711],
  /* :: */
  [
  /* tuple */
  [columnName,
  /* Null */
  870828711],
  /* :: */
  [
  /* tuple */
  [data,
  /* `List */
  [848054398,
  /* [] */
  0]],
  /* [] */
  0]]]]]);

  var arg;

  if (match[0] >= 17724) {
    arg = match[1];
  } else {
    throw [Caml_builtin_exceptions.assert_failure,
    /* tuple */
    ["histogram.ml", 207, 32]];
  }

  var Default = {
    arg: arg
  };
  var Const = {
    Label: Label$1,
    Default: Default
  };

  var numBins$1 = Curry._2(Record_param.flag1, numBins, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Record_param.Arg_type.$$int)));

  var binWeights$1 = Curry._2(Record_param.flag1, binWeights, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$float))));

  var dataWeights$1 = Curry._2(Record_param.flag1, dataWeights, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$float))));

  var columnName$1 = Curry._2(Record_param.flag1, columnName, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Record_param.Arg_type.string)));

  var argType = Curry._1(Record_param.Arg_type.create, function (param) {
    if (typeof param === "number") {
      return (
        /* Invalid */
        144245463
      );
    } else {
      var variant = param[0];

      if (variant !== 3654863 && variant !== 365180284) {
        return (
          /* Invalid */
          144245463
        );
      } else {
        return (
          /* `Ok */
          [17724, param[1]]
        );
      }
    }
  });

  var numericalDataParam = Curry._2(Record_param.flag1, data, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, argType)));

  var loop = function loop(_param) {
    while (true) {
      var param = _param;

      if (typeof param === "number") {
        if (param !== 870828711) {
          return (
            /* Invalid */
            144245463
          );
        } else {
          return (
            /* `Ok */
            [17724, "n/a"]
          );
        }
      } else {
        var variant = param[0];

        if (variant !== -976970511) {
          if (variant !== 737456202) {
            if (variant !== 925978388) {
              return (
                /* Invalid */
                144245463
              );
            } else {
              _param = param[1];
              continue;
            }
          } else {
            return (
              /* `Ok */
              [17724, param[1] ? "true" : "false"]
            );
          }
        } else {
          return (
            /* `Ok */
            [17724, param[1]]
          );
        }
      }
    }

    ;
  };

  var argType$1 = Curry._1(Record_param.Arg_type.create, loop);

  var categoricalDataParam = Curry._2(Record_param.flag1, data, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, argType$1)));

  var to_record = function to_record(numBins$2, binWeights$2, dataWeights$2, columnName$2, data$1) {
    var option = function option(f, t) {
      if (t !== undefined) {
        return (
          /* `Some */
          [925978388, Curry._1(f, Caml_option.valFromOption(t))]
        );
      } else {
        return (
          /* Null */
          870828711
        );
      }
    };

    var string = function string(t) {
      return (
        /* `String */
        [-976970511, t]
      );
    };

    var $$float = function $$float(t) {
      return (
        /* `Float */
        [365180284, t]
      );
    };

    var $$int = function $$int(t) {
      return (
        /* `Int */
        [3654863, t]
      );
    };

    var array = function array(f, t) {
      return (
        /* `List */
        [848054398, Bolt0_list$Bolt0.map(f, $$Array.to_list(t))]
      );
    };

    var match = Curry._1(Record_param.R.of_alist,
    /* :: */
    [
    /* tuple */
    [numBins, option($$int, numBins$2)],
    /* :: */
    [
    /* tuple */
    [binWeights, option(function (param) {
      return array($$float, param);
    }, binWeights$2)],
    /* :: */
    [
    /* tuple */
    [dataWeights, option(function (param) {
      return array($$float, param);
    }, dataWeights$2)],
    /* :: */
    [
    /* tuple */
    [columnName, option(string, columnName$2)],
    /* :: */
    [
    /* tuple */
    [data, data$1],
    /* [] */
    0]]]]]);

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["histogram.ml", 293, 28]];
    }
  };

  var of_record = function of_record(record, dataParam, f) {
    var make = Curry.__5(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, numBins$1)), Curry._1(Record_param.errs, binWeights$1)), Curry._1(Record_param.errs, dataWeights$1)), Curry._1(Record_param.errs, columnName$1)), Curry._1(Record_param.errs, dataParam));

    return Curry._2(Record_param.parse, record, param);
  };

  var dataTypeAvailable = function dataTypeAvailable(x) {
    var param = x;

    if (typeof param === "number") {
      if (param >= 3654864) {
        if (param !== 365180284) {
          return param === 737456202;
        } else {
          return true;
        }
      } else if (param !== -976970511) {
        return param >= 3654863;
      } else {
        return true;
      }
    } else if (param[0] !== 216537025) {
      return false;
    } else {
      var match = param[1];

      if (match >= 3654864) {
        if (match !== 365180284) {
          return match === 737456202;
        } else {
          return true;
        }
      } else if (match !== -976970511) {
        return match >= 3654863;
      } else {
        return true;
      }
    }
  };

  var Const$1 = {
    tag: "Histogram"
  };
  var $$Error$1 = {};
  var tag = "Numerical";

  var bins = Curry._1(Label.named_exn, "bins");

  var counts = Curry._1(Label.named_exn, "counts");

  var weightedCounts = Curry._1(Label.named_exn, "weightedCounts");

  var normalisedCounts = Curry._1(Label.named_exn, "normalisedCounts");

  var density = Curry._1(Label.named_exn, "density");

  var xAxisLabel = Curry._1(Label.named_exn, "xAxisLabel");

  var Label$2 = {
    bins: bins,
    counts: counts,
    weightedCounts: weightedCounts,
    normalisedCounts: normalisedCounts,
    density: density,
    xAxisLabel: xAxisLabel
  };
  var Const$2 = {
    tag: tag,
    Label: Label$2
  };

  var bins$1 = Curry._2(Record_param.flag1, bins, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$float)));

  var counts$1 = Curry._2(Record_param.flag1, counts, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$int)));

  var weightedCounts$1 = Curry._2(Record_param.flag1, weightedCounts, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$float))));

  var normalisedCounts$1 = Curry._2(Record_param.flag1, normalisedCounts, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$float))));

  var density$1 = Curry._2(Record_param.flag1, density, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.option, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$float))));

  var xAxisLabel$1 = Curry._2(Record_param.flag1, xAxisLabel, Curry._1(Record_param.Flag.required, Record_param.Arg_type.string));

  var Param = {
    bins: bins$1,
    counts: counts$1,
    weightedCounts: weightedCounts$1,
    normalisedCounts: normalisedCounts$1,
    density: density$1,
    xAxisLabel: xAxisLabel$1
  };

  var of_record$1 = function of_record$1(record, f) {
    var make = Curry.__6(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, bins$1)), Curry._1(Record_param.errs, counts$1)), Curry._1(Record_param.errs, weightedCounts$1)), Curry._1(Record_param.errs, normalisedCounts$1)), Curry._1(Record_param.errs, density$1)), Curry._1(Record_param.errs, xAxisLabel$1));

    return Curry._2(Record_param.parse, record, param);
  };

  var to_record$1 = function to_record$1(bins$2, counts$2, weightedCounts$2, normalisedCounts$2, density$2, xAxisLabel$2) {
    var value_map = function value_map(t, $$default, f) {
      if (t !== undefined) {
        return Curry._1(f, Caml_option.valFromOption(t));
      } else {
        return $$default;
      }
    };

    var match = Curry._1(Record_param.R.of_alist,
    /* :: */
    [
    /* tuple */
    [bins,
    /* `List */
    [848054398, Bolt0_list$Bolt0.map(function (t) {
      return (
        /* `Float */
        [365180284, t]
      );
    }, $$Array.to_list(bins$2))]],
    /* :: */
    [
    /* tuple */
    [counts,
    /* `List */
    [848054398, Bolt0_list$Bolt0.map(function (t) {
      return (
        /* `Int */
        [3654863, t]
      );
    }, $$Array.to_list(counts$2))]],
    /* :: */
    [
    /* tuple */
    [weightedCounts, value_map(weightedCounts$2,
    /* Null */
    870828711, function (arr) {
      return (
        /* `Some */
        [925978388,
        /* `List */
        [848054398, Bolt0_list$Bolt0.map(function (t) {
          return (
            /* `Float */
            [365180284, t]
          );
        }, $$Array.to_list(arr))]]
      );
    })],
    /* :: */
    [
    /* tuple */
    [normalisedCounts, value_map(normalisedCounts$2,
    /* Null */
    870828711, function (arr) {
      return (
        /* `Some */
        [925978388,
        /* `List */
        [848054398, Bolt0_list$Bolt0.map(function (t) {
          return (
            /* `Float */
            [365180284, t]
          );
        }, $$Array.to_list(arr))]]
      );
    })],
    /* :: */
    [
    /* tuple */
    [density, value_map(density$2,
    /* Null */
    870828711, function (arr) {
      return (
        /* `Some */
        [925978388,
        /* `List */
        [848054398, Bolt0_list$Bolt0.map(function (t) {
          return (
            /* `Float */
            [365180284, t]
          );
        }, $$Array.to_list(arr))]]
      );
    })],
    /* :: */
    [
    /* tuple */
    [xAxisLabel,
    /* `String */
    [-976970511, xAxisLabel$2]],
    /* [] */
    0]]]]]]);

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["histogram.ml", 433, 30]];
    }
  };

  var name = Curry._1(Label.named_exn, "name");

  var count = Curry._1(Label.named_exn, "count");

  var Label$3 = {
    name: name,
    count: count
  };
  var Const$3 = {
    Label: Label$3
  };

  var name$1 = Curry._2(Record_param.flag1, name, Curry._1(Record_param.Flag.required, Record_param.Arg_type.string));

  var count$1 = Curry._2(Record_param.flag1, count, Curry._1(Record_param.Flag.required, Record_param.Arg_type.$$int));

  var Param$1 = {
    name: name$1,
    count: count$1
  };

  var to_record$2 = function to_record$2(name$2, count$2) {
    var match = Curry._1(Record_param.R.of_alist,
    /* :: */
    [
    /* tuple */
    [name,
    /* `String */
    [-976970511, name$2]],
    /* :: */
    [
    /* tuple */
    [count,
    /* `Int */
    [3654863, count$2]],
    /* [] */
    0]]);

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["histogram.ml", 466, 32]];
    }
  };

  var of_record$2 = function of_record$2(record, f) {
    var make = Curry.__2(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, name$1)), Curry._1(Record_param.errs, count$1));

    return Curry._2(Record_param.parse, record, param);
  };

  var Bin = {
    Const: Const$3,
    Param: Param$1,
    to_record: to_record$2,
    of_record: of_record$2
  };
  var tag$1 = "Categorical";

  var bins$2 = Curry._1(Label.named_exn, "bins");

  var xAxisLabel$2 = Curry._1(Label.named_exn, "xAxisLabel");

  var Label$4 = {
    bins: bins$2,
    xAxisLabel: xAxisLabel$2
  };
  var Const$4 = {
    tag: tag$1,
    Label: Label$4
  };

  var bins$3 = Curry._2(Record_param.flag1, bins$2, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.list, Record_param.Arg_type.record)));

  var xAxisLabel$3 = Curry._2(Record_param.flag1, xAxisLabel$2, Curry._1(Record_param.Flag.required, Record_param.Arg_type.string));

  var of_record$3 = function of_record$3(record, f) {
    var make = Curry.__2(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, bins$3)), Curry._1(Record_param.errs, xAxisLabel$3));

    return Curry._2(Record_param.parse, record, param);
  };

  var to_record$3 = function to_record$3(bins$4, xAxisLabel$4) {
    var match = Curry._1(Record_param.R.of_alist,
    /* :: */
    [
    /* tuple */
    [bins$2,
    /* `List */
    [848054398, Bolt0_list$Bolt0.map(function (x) {
      return (
        /* `Record */
        [847309489, x]
      );
    }, bins$4)]],
    /* :: */
    [
    /* tuple */
    [xAxisLabel$2,
    /* `String */
    [-976970511, xAxisLabel$4]],
    /* [] */
    0]]);

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["histogram.ml", 523, 30]];
    }
  };

  var of_record$4 = function of_record$4(record, param, categorical) {
    var e = Curry._2(Record_param.Tagged.parse, record, Record_param.Arg_type.record);

    if (e[0] >= 106380200) {
      return e;
    } else {
      var match = e[1];
      var tag$2 = match[0];

      if (Bolt0_string$Bolt0.equal(tag$2, tag$1)) {
        return of_record$3(match[1], categorical);
      } else if (Bolt0_string$Bolt0.equal(tag$2, tag)) {
        return Pervasives.failwith("nyi");
      } else {
        return (
          /* `Error */
          [106380200,
          /* :: */
          [
          /* tuple */
          [Record_param.Tagged.Const.Label.tag,
          /* Invalid */
          144245463],
          /* [] */
          0]]
        );
      }
    }
  };

  return {
    Private: Private,
    $$Error: $$Error,
    Arg: {
      Const: Const,
      Param: {
        numBins: numBins$1,
        binWeights: binWeights$1,
        dataWeights: dataWeights$1,
        columnName: columnName$1,
        categoricalDataParam: categoricalDataParam,
        numericalDataParam: numericalDataParam
      },
      to_record: to_record,
      of_record: of_record,
      dataTypeAvailable: dataTypeAvailable
    },
    T: {
      Const: Const$1,
      $$Error: $$Error$1,
      Numerical: {
        Const: Const$2,
        Param: Param,
        to_record: to_record$1,
        of_record: of_record$1
      },
      Categorical: {
        Bin: Bin,
        Const: Const$4,
        to_record: to_record$3,
        of_record: of_record$3
      },
      of_record: of_record$4
    }
  };
}

export { Make };
/* No side effect */